import { get, post } from "../../network/endpoint";
import { dispatchHandler } from "services/utils/action";
import { BFF } from "../../network/routes";

import * as ActionTypes from "services/state/action-types";

export function getSVAs(customerId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { customerId },
      client: BFF,
    };
    const request = get("getSvas", config);

    return dispatch({
      type: ActionTypes.GET_SVAS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getServiceRequests(
  customerId,
  assetId,
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = {
      pathValues: {
        assetId,
        customerId,
        page: 0,
        size: 100,
      },
      client: BFF,
    };
    const request = get("getServiceRequests", config);

    return dispatch({
      type: ActionTypes.GET_SERVICE_REQUESTS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getRemainingHours(customerId, assetId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: {
        assetId,
        customerId,
      },
      client: BFF,
    };
    const request = get("getRemainingHours", config);

    return dispatch({
      type: ActionTypes.GET_REMAINING_HOURS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function saveServiceRequest(data, callback) {
  return (dispatch) => {
    const config = { data, client: BFF };
    const request = post("createServiceRequest", config);

    return dispatch({
      type: ActionTypes.SAVE_SERVICE_REQUEST,
      payload: request,
    })
      .then((response) => {
        let status;

        if (response.type === ActionTypes.SAVE_SERVICE_REQUEST_FAIL) {
          status = "ERROR";
        } else {
          status = "SUCCESS";
        }

        if (!!response && !!response.payload && !!response.payload.data) {
          return callback && callback(response.payload.data, status);
        }

        if (
          !!response &&
          !!response.error.response &&
          !!response.error.response.data
        ) {
          return callback && callback(response.error.response.data, status);
        }

        // callback && callback(response, status);
      })
      .catch((error) => {
        console.error("Error: ", error);
      });
  };
}

export function findAllAssets(assetId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: {
        assetId,
      },
      client: BFF,
    };
    const request = get("findAllAssetDetail", config);

    return dispatch({
      type: ActionTypes.FIND_ALL_ASSETS,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}



// WEBPACK FOOTER //
// ./src/services/state/interface/action.js